import React from "react";
import { empty } from "../../../utils";

const FrontCanvas = React.memo((props) => {
    if (props.promotionalItem == null) {
        return null;
    }

    let logoImage = null;
    if (parseInt(props.logo) === 1) {
        // UTP
        logoImage = (
            <img
                src="https://ac-ut-health.s3.us-east-1.amazonaws.com/css/utp-logo-030325.png"
                alt="UTP"
                className="utp-logo"
            />
        );
    } else if (parseInt(props.logo) === 2) {
        // UTH
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/uth-new-logo-low.png"
                alt="UTH"
                className="uth-utp-logo"
            />
        );
    } else if (parseInt(props.logo) === 3) {
        // UTH Houston
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/uth-houston-logo.png"
                alt="UTH Houston"
                className="uth-houston-logo"
            />
        );
    } else if (parseInt(props.logo) === 4) {
        // Cizik School of Nursing
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/uth-cizik.logo.png"
                alt="Cizik School of Nursing"
                className="uth-cizik-logo"
            />
        );
    } else if (parseInt(props.logo) === 5) {
        // McGovern Medical School
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/uth-mcgovern-logo.png"
                alt="McGovern Medical School"
                className="uth-mcgovern-logo"
            />
        );
    } else if (parseInt(props.logo) === 6) {
        // School of Biomedical Informatics
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/uth-biomedical-informatics-logo.png"
                alt="School of Biomedical Informatics"
                className="uth-biomedical-informatics-logo"
            />
        );
    } else if (parseInt(props.logo) === 7) {
        // School of Dentistry
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/uth-dentistry-logo.png"
                alt="School of Dentistry"
                className="uth-dentistry-logo"
            />
        );
    } else if (parseInt(props.logo) === 8) {
        // School of Public Health
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/uth-public-health-logo.png"
                alt="School of Public Health"
                className="uth-public-health-logo"
            />
        );
    } else if (parseInt(props.logo) === 9) {
        // UTHealth Houston General
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/uth-general-logo.png"
                alt="UTHealth Houston General"
                className="uth-general-logo"
            />
        );
    } else if (parseInt(props.logo) === 10) {
        // School of Public Health - Austin
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-austin.png"
                alt="School of Public Health - Austin"
                className="uth-public-health-austin-logo"
            />
        );
    } else if (parseInt(props.logo) === 11) {
        // School of Public Health - Brownsville
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-brownsville.png"
                alt="School of Public Health - Brownsville"
                className="uth-public-health-brownsville-logo"
            />
        );
    } else if (parseInt(props.logo) === 12) {
        // School of Public Health - Dallas
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-dallas.png"
                alt="School of Public Health - Dallas"
                className="uth-public-health-dallas-logo"
            />
        );
    } else if (parseInt(props.logo) === 13) {
        // School of Public Health - El Paso
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-el-paso.png"
                alt="School of Public Health - El Paso"
                className="uth-public-health-el-paso-logo"
            />
        );
    } else if (parseInt(props.logo) === 14) {
        // School of Public Health - San Antonio
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-san-antonio.png"
                alt="School of Public Health - San Antonio"
                className="uth-public-health-san-antonio-logo"
            />
        );
    } else if (parseInt(props.logo) === 15) {
        // UTHealth Houston Children's Heart Institute
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/uth-childrens-heart.png"
                alt="UTHealth Houston Children's Heart Institute"
                className="uth-childrens-heart"
            />
        );
    } else if (parseInt(props.logo) === 16) {
        // McWilliams School of Biomedical Informatics
        logoImage = (
            <img
                src="https://ac-ut-health.s3.amazonaws.com/css/mcwilliams-logo-v82923.png"
                alt="McWilliams School of Biomedical Informatics"
                className="uth-childrens-heart"
            />
        );
    }

    if (parseInt(props.templateId) === 16) {
        logoImage = null;
    }

    let imageUrl = props.promotionalItem.image_url;
    if (
        props.user.username === "utdemo" &&
        !empty(props.promotionalItem.preview_image_url_demo)
    ) {
        imageUrl = props.promotionalItem.preview_image_url_demo;
    }

    return (
        <div className="front-canvas-container">
            <h5>Preview</h5>
            <div className="preview-image">
                <img src={imageUrl} alt="Apparel" />
            </div>
            <div className="logo-image">{logoImage}</div>
        </div>
    );
});

export default FrontCanvas;
